import {restPrefixV1} from './urls';

const PREFIX = `${restPrefixV1}/telepulesek`;

export default {
	getAddressesOnSettlement: param => window.axios.get(`${PREFIX}/kereses?${parseInt(param) ? 'irszam' : 'nevReszlet'}=${encodeURIComponent(param)}`),
	getStreetsByTelepulesId: telepulesId => window.axios.get(`${PREFIX}/cim?telepulesId=${telepulesId}`),
	postChangeAddress: params => window.axios.post(`${PREFIX}/change-address`, params),
	changeActiveAddress: params => window.axios.post(`${PREFIX}/activate-address`, params),
	postForceChangeAddress: params => window.axios.post(`${PREFIX}/change-address?force=true`, params),
	createCartWithAddress: params => window.axios.post(`${PREFIX}/create-address`, params)
};



// WEBPACK FOOTER //
// ../source/common/api/settlement.api.js